import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export const useTemporaryQueryParam = (key: string) => {
    const router = useRouter();
    const queryValue = router.query[key];
    const value = Array.isArray(queryValue) ? queryValue[0] : queryValue;
    const state = useState(value);

    useEffect(() => {
        if (!value) {
            const url = new URL(window.location.href);
            const value = url.searchParams.get(key);
            if (!value) return;
            state[1](value);
            url.searchParams.delete(key);
            router.replace(url.toString());
            return;
        }

        const newQuery = { ...router.query };
        delete newQuery[key];

        router.replace(
            {
                pathname: router.pathname,
                query: newQuery,
            },
            undefined,
            { shallow: true },
        );
    }, []);

    return state;
};
